import { normalize } from 'normalizr'

import mixpanel, { EVENTS } from 'services/mix-panel'
import schema from './schema'

export const FETCHED_ALL = 'ADDRESS/FETCHED_ALL'
export const FETCHED_ONE = 'ADDRESS/FETCHED_ONE'
export const REMOVED = 'ADDRESS/REMOVED'
export const FETCHED_DEFAULT = 'ADDRESS/FETCHED_DEFAULT'

export function fetchAll() {
  return async (dispatch, getState, api) => {
    const response = await api.address.fetchAll()
    dispatch({
      type: FETCHED_ALL,
      payload: normalize(response, [schema]),
    })
    return response
  }
}

export function fetchOne(id) {

  return async (dispatch, getState, api) => {
    const response = await api.address.fetchOne(id)
    dispatch({
      type: FETCHED_ONE,
      payload: normalize(response, schema),
    })
    return response
  }
}

export function fetchDefault() {
  return async (dispatch, getState, api) => {
    try {
      const response = await api.address.getDefault()
      dispatch({
        type: FETCHED_DEFAULT,
        payload: normalize(response ?? {}, schema),
      })
      return response
    } catch (_error) {
      dispatch({
        type: FETCHED_DEFAULT,
        payload: normalize({}, schema),
      })
      return null
    }
  }
}

export function create(data) {
  return async (dispatch, getState, api) => {
    const response = await api.address.create(data)

    mixpanel.track(EVENTS.ALARM_SET)
    dispatch({
      type: FETCHED_ONE,
      payload: normalize(response, schema),
    })
    return response
  }
}

export function update(id, data) {
  return async (dispatch, getState, api) => {
    const response = await api.address.update(id, data)
    dispatch({
      type: FETCHED_ONE,
      payload: normalize(response, schema),
    })
    return response
  }
}

export function remove(id) {
  return async (dispatch, getState, api) => {
    const response = await api.address.remove(id)
    dispatch({
      type: REMOVED,
      payload: id,
    })
    return response
  }
}
